import gql from 'graphql-tag';

export const getIsEnableSoftBlockOrder = gql`
  query getIsEnableSoftBlockOrder($tenantId: Int!, $customerId: Int!) {
    getIsEnableSoftBlockOrder(tenantId: $tenantId, customerId: $customerId)
  }
`;

export const getShowRangeForEstimateWeightConfig = gql`
  query getShowRangeForEstimateWeightConfig($tenantId: Int!) {
    getShowRangeForEstimateWeightConfig(tenantId: $tenantId)
  }
`;
